export enum FormLayout {
  HORIZONTAL = "HORIZONTAL",
  VERTICAL = "VERTICAL",
}
